export const logoList = [
  {
    href: 'https://cliffeyewear.com/',
    src: "https://visioncaredivision.com.np/images/cliff.png",
    alt: "Logo of Cliff Eyewear",
    title: "Cliff Eyewear"
  },
  {
    href: 'https://www.zeiss.com',
    src: "https://visioncaredivision.com.np/images/ZEiss.jpg",
    alt: "Logo of ZEISS",
    title: "ZEISS"
  },
  {
    href: 'https://coopervision.com/',
    src: "/images/coopervision.jpg",
    alt: "Logo of Cooper Vision",
    title: "Cooper Vision"
  },
  {
    href: 'http://image-eyewear.com/',
    src: "/images/image.jpg",
    alt: "Logo of ImageEyeware",
    title: "Image Eyeware"
  },
  {
    href: 'https://www.idee-eyewear.com/brands/irus-by-idee.html',
    src: "/images/IRUS.jpg",
    alt: "Logo of IRUS",
    title: "Idee Eye Wear"
  },
]